module.exports = __webpack_public_path__ + "img/mon_64.1ce52a03.png";